import styled from "styled-components";

export const ErrorStyle = styled.span`
  color: red;
`